import React from 'react';
import clsx from 'clsx';

export const TableRowElement = (({ children, hideBorder, ...props }, ref) => {
  const { attributes } = props;
  const { className } = attributes || {};
  return (
    <tr
      ref={ref}
      className={clsx(className, hideBorder && 'border-none')}
      {...attributes}
    >
      {children}
    </tr>
  );
});
